import React, { useState } from "react";
import { Link, useLocation, NavLink } from "react-router-dom";
import ThemeToggleButton from "./ThemeToggleButton";
import LanguageSwitcher from "./LanguageSwitcher";
import { useLanguage } from "../context/LanguageContext";
import { isImpersonating, stopImpersonation } from "../utils/impersonation";

const NavbarRescricted = () => {
  const location = useLocation();
  const { t } = useLanguage();
  const simulating = isImpersonating();

  const token = localStorage.getItem("token");
  const tokenAcesso = localStorage.getItem("tokenAcesso");
  const isValid = (t) => {
    if (!t) return false;
    const clean = t.replace(/^["']|["']$/g, "").trim();
    return clean !== "" && clean !== "undefined" && clean !== "null";
  };
  const isLogged = isValid(token) || isValid(tokenAcesso);

  const logout = () => {
    if (isImpersonating()) {
      stopImpersonation();
      return;
    }
    localStorage.removeItem("tokenAcesso");
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    window.location.href = "/";
  };

  return (
    <div
      className={`navbar fixed ${
        simulating ? "top-[38px] sm:top-[40px]" : "top-0"
      } mx-auto shadow-xl bg-base-200 z-10 bg-opacity-95 transition-all`}
    >
      <div className="navbar-start">
        <NavLink to={isLogged ? "/ar/shop" : "/"} className="btn btn-ghost text-xl">
          <svg
            version="1.0"
            xmlns="http://www.w3.org/2000/svg"
            width="50px"
            height="50px"
            viewBox="0 0 500.000000 500.000000"
            preserveAspectRatio="xMidYMid meet"
          >
            <g
              transform="translate(0.000000,500.000000) scale(0.100000,-0.100000)"
              fill="#000000"
              stroke="none"
            >
              <path
                d="M2330 4994 c-499 -44 -906 -181 -1284 -431 -404 -268 -720 -675 -880
                  -1133 -46 -132 -86 -280 -77 -280 4 0 13 19 20 43 7 23 30 79 51 123 136 282
                  515 353 756 141 25 -22 57 -58 73 -81 38 -56 681 -1840 681 -1891 0 -35 -51
                  -72 -117 -85 -183 -36 -278 -75 -343 -140 -44 -44 -79 -110 -80 -147 l0 -23
                  373 0 c204 0 406 5 447 10 256 34 488 195 595 415 19 39 61 144 95 235 107
                  288 112 301 133 321 15 14 35 19 76 19 110 0 184 37 221 110 11 22 20 55 20
                  75 l0 35 -121 0 c-111 0 -121 2 -116 18 4 15 208 583 223 622 9 24 22 -9 167
                  -415 252 -708 339 -966 344 -1020 8 -79 -12 -167 -63 -272 -36 -75 -60 -108
                  -127 -176 -179 -182 -466 -329 -821 -422 -240 -63 -296 -69 -566 -69 -228 0
                  -254 1 -370 26 -711 153 -1283 658 -1519 1341 -49 143 -89 328 -98 451 -6 100
                  -22 152 -23 75 0 -83 20 -302 40 -424 90 -561 366 -1063 781 -1419 346 -297
                  795 -508 1246 -585 444 -75 865 -46 1275 89 653 215 1160 684 1436 1330 54
                  125 136 369 128 378 -3 2 -9 -4 -12 -14 -4 -10 -20 -52 -37 -93 -86 -212 -335
                  -335 -562 -276 -121 32 -242 120 -299 218 -14 23 -133 343 -266 712 -133 369
                  -273 758 -312 865 -76 210 -87 255 -69 288 17 32 53 47 171 71 192 41 298 110
                  345 227 l24 59 -292 6 c-347 8 -578 -2 -696 -31 -277 -67 -435 -262 -597 -733
                  -31 -93 -65 -178 -74 -190 -14 -16 -34 -22 -94 -28 -126 -12 -208 -80 -218
                  -179 l-3 -35 118 -3 c64 -1 117 -6 117 -11 0 -5 -11 -37 -24 -72 -55 -148
                  -196 -548 -196 -558 0 -30 -17 -4 -39 57 -12 37 -97 272 -188 522 -289 797
                  -285 785 -279 862 13 177 130 343 365 519 234 174 488 284 791 341 155 30 500
                  32 661 5 313 -53 596 -163 854 -332 299 -196 522 -445 680 -758 116 -231 188
                  -482 202 -704 3 -51 10 -93 14 -93 26 0 1 309 -41 520 -85 420 -239 779 -464
                  1075 -74 98 -256 287 -353 366 -347 285 -785 471 -1258 534 -116 16 -452 27
                  -545 19z"
              />
            </g>
          </svg>
        </NavLink>
      </div>
      <div className="navbar-center ml-6 flex">
        {isLogged && (
          <div className="flex justify-center items-center">
          <ul tabIndex={0} className="flex space-x-2">
            <li
              className={`flex flex-col items-center px-1 ${
                location.pathname === "/ar/shop" ? "text-blue-500" : ""
              }`}
            >
              <NavLink to="/ar/shop">
                {location.pathname === "/ar/shop" ? (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    height="32px"
                    viewBox="0 -960 960 960"
                    width="32px"
                    fill="#3b82f6"
                  >
                    <path d="M830.2-521.49v328.93q0 25.84-18.35 44.2Q793.49-130 767.64-130H192.1q-25.84 0-44.2-18.36-18.36-18.36-18.36-44.2v-329.7q-26.46-21.33-36.76-53.93-10.29-32.6.66-67.4l40.87-131.74q8-25.9 26.95-40.28Q180.21-830 206.15-830h544.77q26.77 0 46.28 14.23 19.52 14.23 27.47 39.67l42.3 132.51q10.95 34.8.32 67.58-10.62 32.78-37.09 54.52Zm-261.17-23.64q33.84 0 53.19-20.37 19.34-20.37 15.93-45.27l-25.79-168.97H505.33v166.25q0 27.54 18.44 47.95 18.43 20.41 45.26 20.41Zm-183.39 0q29.92 0 49.68-20.07 19.76-20.08 19.76-48.29v-166.25H347.79L322-609.23q-3.23 22.38 15.08 43.24 18.3 20.86 48.56 20.86Zm-179.9 0q24.95 0 43.11-17.19 18.15-17.19 21.66-42.55l25.44-174.87h-95.49q-6.54 0-10.51 2.88-3.98 2.89-5.64 8.65L142.87-632.1q-9.82 30.79 8.21 58.88 18.02 28.09 54.66 28.09Zm548.26 0q33.95 0 53.82-26.98 19.87-26.99 9.46-59.99l-42.36-136.87q-1.66-5.77-5.64-8.27-3.97-2.5-10.51-2.5H664.2l25.44 174.87q3.77 25.36 21.8 42.55 18.02 17.19 42.56 17.19Z" />
                  </svg>
                ) : (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    height="32px"
                    viewBox="0 -960 960 960"
                    width="32px"
                    fill="#000000"
                  >
                    <path d="M830.2-521.49v328.93q0 25.84-18.35 44.2Q793.49-130 767.64-130H192.1q-25.84 0-44.2-18.36-18.36-18.36-18.36-44.2v-329.7q-26.46-21.33-36.76-53.93-10.29-32.6.66-67.4l40.87-131.74q8-25.9 26.95-40.28Q180.21-830 206.15-830h544.77q26.77 0 46.28 14.23 19.52 14.23 27.47 39.67l42.3 132.51q10.95 34.8.32 67.58-10.62 32.78-37.09 54.52Zm-261.17-23.64q33.84 0 53.19-20.37 19.34-20.37 15.93-45.27l-25.79-168.97H505.33v166.25q0 27.54 18.44 47.95 18.43 20.41 45.26 20.41Zm-183.39 0q29.92 0 49.68-20.07 19.76-20.08 19.76-48.29v-166.25H347.79L322-609.23q-3.23 22.38 15.08 43.24 18.3 20.86 48.56 20.86Zm-179.9 0q24.95 0 43.11-17.19 18.15-17.19 21.66-42.55l25.44-174.87h-95.49q-6.54 0-10.51 2.88-3.98 2.89-5.64 8.65L142.87-632.1q-9.82 30.79 8.21 58.88 18.02 28.09 54.66 28.09Zm548.26 0q33.95 0 53.82-26.98 19.87-26.99 9.46-59.99l-42.36-136.87q-1.66-5.77-5.64-8.27-3.97-2.5-10.51-2.5H664.2l25.44 174.87q3.77 25.36 21.8 42.55 18.02 17.19 42.56 17.19ZM192.1-180.26h575.54q5.13 0 8.72-3.46 3.59-3.46 3.59-8.84V-498q-3.82 1.97-11.05 2.55-7.23.58-14.9.58-25.92 0-47.37-10.52-21.45-10.51-41.76-33.12-16.02 19.84-39.43 31.74-23.41 11.9-54.36 11.9-26.95 0-48.54-9.96-21.59-9.97-42.33-30.71-17.72 19.92-41.39 30.3-23.67 10.37-49.23 10.37-28.15 0-52.05-10.22t-41.23-33.42q-26.72 25.23-49.27 34.43-22.55 9.21-41.3 9.21-7.25 0-14.15-.58t-11.8-2.55v305.44q0 5.38 3.59 8.84t8.72 3.46Zm575.54 0H192.1h575.54Z" />
                  </svg>
                )}
              </NavLink>
              <div className="text-xs text-center pt-[5px]">{t("common.shop")}</div>
            </li>
            <li
              className={`flex flex-col items-center px-1 ${
                location.pathname === "/ar/compras" ? "text-blue-500" : ""
              }`}
            >
              <NavLink to="/ar/compras">
                {location.pathname === "/ar/compras" ? (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    height="32px"
                    viewBox="0 -960 960 960"
                    width="32px"
                    fill="#3b82f6"
                  >
                    <path d="M242.57-100q-25.79 0-44.18-18.39T180-162.57v-474.86q0-25.79 18.39-44.18T242.57-700h92.3v-14.87q0-60.67 42.23-102.9Q419.33-860 480-860q60.67 0 102.9 42.23 42.23 42.23 42.23 102.9V-700h92.3q25.79 0 44.18 18.39T780-637.43v474.86q0 25.79-18.39 44.18T717.43-100H242.57Zm142.56-600h189.74v-14.87q0-39.92-27.47-67.4-27.48-27.47-67.4-27.47t-67.4 27.47q-27.47 27.48-27.47 67.4V-700ZM600-529.74q10.87 0 18-7.13 7.13-7.14 7.13-18v-94.87h-50.26v94.87q0 10.86 7.14 18 7.13 7.13 17.99 7.13Zm-240 0q10.87 0 18-7.13 7.13-7.14 7.13-18v-94.87h-50.26v94.87q0 10.86 7.14 18 7.13 7.13 17.99 7.13Z" />
                  </svg>
                ) : (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    height="32px"
                    viewBox="0 -960 960 960"
                    width="32px"
                    fill="#000000"
                  >
                    <path d="M242.57-100q-25.79 0-44.18-18.39T180-162.57v-474.86q0-25.79 18.39-44.18T242.57-700h92.3v-14.87q0-60.67 42.23-102.9Q419.33-860 480-860q60.67 0 102.9 42.23 42.23 42.23 42.23 102.9V-700h92.3q25.79 0 44.18 18.39T780-637.43v474.86q0 25.79-18.39 44.18T717.43-100H242.57Zm0-50.26h474.86q4.62 0 8.47-3.84 3.84-3.85 3.84-8.47v-474.86q0-4.62-3.84-8.47-3.85-3.84-8.47-3.84h-92.3v94.87q0 10.7-7.25 17.91-7.25 7.22-18 7.22T582-536.96q-7.13-7.21-7.13-17.91v-94.87H385.13v94.87q0 10.7-7.25 17.91-7.25 7.22-18 7.22T342-536.96q-7.13-7.21-7.13-17.91v-94.87h-92.3q-4.62 0-8.47 3.84-3.84 3.85-3.84 8.47v474.86q0 4.62 3.84 8.47 3.85 3.84 8.47 3.84ZM385.13-700h189.74v-14.87q0-39.92-27.47-67.4-27.48-27.47-67.4-27.47t-67.4 27.47q-27.47 27.48-27.47 67.4V-700ZM230.26-150.26v-499.48 499.48Z" />
                  </svg>
                )}
              </NavLink>
              <div className="text-xs pt-[5px]">{t("common.myOrders")}</div>
            </li>
          </ul>
          </div>
        )}
      </div>

      <div className="navbar-end gap-3 sm:gap-4 mr-3 sm:mr-5">
        <LanguageSwitcher />

        {isLogged ? (
          <div className="flex flex-col items-center">
            <a href="/" onClick={logout}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                height="32px"
                width="32px"
                viewBox="0 -960 960 960"
                fill="#000000"
              >
                <path d="M202.57-140q-25.79 0-44.18-18.39T140-202.57v-554.86q0-25.79 18.39-44.18T202.57-820h277.4v50.26h-277.4q-4.62 0-8.47 3.84-3.84 3.85-3.84 8.47v554.86q0 4.62 3.84 8.47 3.85 3.84 8.47 3.84h277.4V-140h-277.4Zm459.38-181.54-35.85-35.95 97.39-97.38H363.85v-50.26h358.82l-97.39-97.38 35.59-36.21L820-479.46 661.95-321.54Z" />
              </svg>
            </a>
            <div className="text-xs pt-[4px]">{t("common.logout")}</div>
          </div>
        ) : (
          <a className="text-lg sm:text-xl font-semibold">Adauto A. Araujo</a>
        )}
      </div>
    </div>
  );
};

export default NavbarRescricted;
